import { useState, useEffect } from 'preact/hooks';
import { api } from '../../api/client';
import { SkillCardNew } from './SkillCardNew';
import type { SkillMeta } from './types';
import { T } from '../../styles/tokens';

interface Props {
  search: string;
  onDetails: (s: SkillMeta) => void;
  onInstall: (s: SkillMeta) => void;
}

export function TabVerified({ search, onDetails, onInstall }: Props) {
  const [skills, setSkills] = useState<SkillMeta[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get<any>('/cloud/skills-pack/manifest')
      .then((r: any) => {
        const list = r?.skills || r?.data?.skills || [];
        setSkills(list.filter((s: SkillMeta) => s.tier === 'tier1' || s.verified));
      })
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  const filtered = skills.filter(s => {
    if (!search) return true;
    const q = search.toLowerCase();
    return s.name.toLowerCase().includes(q) || (s.description_pt || s.description || '').toLowerCase().includes(q);
  });

  if (loading) return <SkeletonGrid />;

  return (
    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))', gap: '16px' }}>
      {filtered.length === 0 ? (
        <div style={{ gridColumn: '1 / -1', textAlign: 'center', padding: '60px 20px', color: T.textSecondary }}>
 <div style={{ fontSize: '48px', marginBottom: '12px' }}></div>
          <div style={{ fontSize: '16px', fontWeight: 600 }}>Nenhuma skill verificada encontrada</div>
        </div>
      ) : filtered.map((s, i) => (
        <SkillCardNew key={s.name} skill={s} index={i} onDetails={onDetails} onInstall={onInstall} />
      ))}
    </div>
  );
}

function SkeletonGrid() {
  return (
    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))', gap: '16px' }}>
      {Array.from({ length: 6 }).map((_, i) => (
        <div key={i} style={{
          height: '200px', borderRadius: '16px',
          background: `linear-gradient(90deg, ${T.purpleBgSubtle} 25%, ${T.purpleBg} 50%, ${T.purpleBgSubtle} 75%)`,
          backgroundSize: '200% 100%', animation: 'skeletonShimmer 1.5s infinite',
        }} />
      ))}
    </div>
  );
}
